// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"i7-z"};